import { APIClient } from "../apiCore";
import * as url from "../urls";
import {m9sGlobals} from "../../config";
import {MainMetaType} from "../../redux/Main/common";
import {createPaginationQuery} from "../../helpers/functions";

const api = new APIClient();

const getSaleCurrencies = (data:MainMetaType) => {
    const query = createPaginationQuery(data);
  return api.get(m9sGlobals.CURRENT_CABINET+url.GET_SALE_CURRENCIES+"?"+query);
};

const sendDataSaleCurrency = (data: any) => {
    return api.create(m9sGlobals.CURRENT_CABINET+url.UPDATE_SALE_CURRENCY, data);
};

const removeSaleCurrency = (data: any) => {
    return api.create(m9sGlobals.CURRENT_CABINET+url.REMOVE_SALE_CURRENCY, data);
};

export {
    getSaleCurrencies,
    sendDataSaleCurrency,
    removeSaleCurrency
};
